export const CODE_LENGTH = 6;
export const INITIAL_CODE_LIFETIME = 10 * 60;
export const CODE_COOLDOWN_OFFSET = 7 * 60;
export const CODE_COOLDOWN_STARTED_COOKIE = '_code_cooldown_started';
export const EMPTY_CODE = Array.from({ length: CODE_LENGTH }, () => '');
